import { Case } from '@app/shared/models/case';
import { CaseService, CaseUriBuilderParams } from '@app/core/services/case.service';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BasePatchComponent } from '@app/shared/components/base/base-patch.component';
import { OnDestroy, Directive } from '@angular/core';
import { OP } from '@app/core/services/base/base-service-with-bundle.service';
import { Office } from '@app/shared/models/office';
import { AppModuleRoutes } from '@app/app-routes';

@Directive()
export class CaseComponent extends BasePatchComponent<Case, CaseUriBuilderParams>
                           implements OnDestroy {

  protected paramsIdNames = ['id'];
  protected myConfig = { fetchAtInit: true };

  get case() {
    return this.updated;
  }

  constructor(protected componentServiceBundle: ComponentServiceBundle, protected caseService: CaseService) {
    super(componentServiceBundle, caseService);
  }

  protected buildBreadcrumb(): void {
    this.breadcrumbsService.breadcrumbs.unshift({ url: '#', label: this.case.case_no, disabled: true });
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected whenOriginalFetched(): void {
    this.officeSelectionCheck();
  }

  protected generateUriBuilderParams(): CaseUriBuilderParams | undefined {
    if (this.myUriIdsList && this.myUriIdsList.length === this.paramsIdNames.length) {
      return new CaseUriBuilderParams(this.myUriIdsList[0]);
    }
  }

  protected patchOffice(office: Office, callbackFn?: Function): void {
    if (office) {
      const data = [{
        op: OP.replace,
        path: 'office_id',
        value: office.id
      }, {
        op: OP.replace,
        path: 'office',
        value: office.officeCode
      }];

      this.patchOpDataArray(data, callbackFn);
    }
  }

  protected officeSelectionCheck(): void {
    if (this.case && !this.case.office_id) {
      const subscription = this.caseService.openCaseCreationDialog(this.case, this.currentUser, true, false)
          .subscribe(officeResult => {
            if (officeResult && officeResult.office) {
              this.patchOffice(officeResult.office);
            } else {
              this.router.navigateByUrl(AppModuleRoutes.DASHBOARD)
                         .then();
            }
          });

      this.subscriptions.push(subscription);
    }
  }
}

